module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/vadosloginov-bkg-259ea1588f0db898f43143b9e0ecefb4.jpg";